"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("react"),n=u=>{const e=t.useRef(!1);t.useEffect(()=>{e.current||(e.current=!0,u())},[])};exports.useOnMount=n;
